export {
  allSwiper
};
import Swiper from "swiper/bundle";

const allSwiper = () => {
  jQuery(document).ready(function ($) {
    $(".swiper-container-images").each(function (index, element) {
      let $this = $(this);
      $this.children(".swiper").addClass("instance-gallery-" + index);
      $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
      $this.find(".swiper-button-next").addClass("btn-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-gallery-" + index);
      let swiperGallery = new Swiper(".instance-gallery-" + index, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        observer: true,

        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 1,
            spaceBetween: 40,
          },
        },
        pagination: {
          el: ".swiper-pagination-gallery-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        navigation: {
          nextEl: ".btn-next-" + index,
          prevEl: ".btn-prev-" + index,
        },
      });
    });
    $(".block-swiper-content-fullwidth").each(function (index, element) {
      let $this = $(this);
      $this.children(".swiper").addClass("instance-content-fullwidth-" + index);
      $this
        .find(".swiper-button-prev")
        .addClass("btn-content-fullwidth-prev-" + index);
      $this
        .find(".swiper-button-next")
        .addClass("btn-content-fullwidth-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-content-fullwidth-" + index);
      let swiperContentFullwidth = new Swiper(".instance-content-fullwidth-" + index, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        // observer: true,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination-content-fullwidth-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        navigation: {
          nextEl: ".btn-content-fullwidth-next-" + index,
          prevEl: ".btn-content-fullwidth-prev-" + index,
        },
      });
      // Cacher l'option de navigation si le swiper contient un seul élément
      if (swiperContentFullwidth.slides.length <= 1) {
        swiperContentFullwidth.navigation.destroy();
        $(swiperContentFullwidth.navigation.nextEl).hide();
        $(swiperContentFullwidth.navigation.prevEl).hide();
      }
    });
    $(".block-swiper-content-labels").each(function (index, element) {
      let $this = $(this);
      $this.children(".swiper").addClass("instance-content-labels-" + index);
      $this
        .find(".swiper-button-prev")
        .addClass("btn-content-labels-prev-" + index);
      $this
        .find(".swiper-button-next")
        .addClass("btn-content-labels-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-content-labels-" + index);
      let swiperContent = new Swiper(".instance-content-labels-" + index, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        // observer: true,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination-content-labels-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
        navigation: {
          nextEl: ".btn-content-labels-next-" + index,
          prevEl: ".btn-content-labels-prev-" + index,
        },
      });
    });
    $(".block-swiper-content-reviews").each(function (index, element) {
      let $this = $(this);
      $this.children(".swiper").addClass("instance-content-reviews-" + index);
      $this
        .find(".swiper-button-prev")
        .addClass("btn-content-reviews-prev-" + index);
      $this
        .find(".swiper-button-next")
        .addClass("btn-content-reviews-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-content-reviews-" + index);
      let swiperContent = new Swiper(".instance-content-reviews-" + index, {
        slidesPerView: 1,
        spaceBetween: 30, 
        loop: false,
        // observer: true,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination-content-reviews-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 2,
            spaceBetween: 75,
          },
        },
        navigation: {
          nextEl: ".btn-content-reviews-next-" + index,
          prevEl: ".btn-content-reviews-prev-" + index,
        },
      });
    });
    $(".block-swiper-content-category-rooms").each(function (index, element) {
      let $this = $(this);
      $this.children(".swiper").addClass("instance-content-category-rooms-" + index);
      $this
        .find(".swiper-button-prev")
        .addClass("btn-content-category-rooms-prev-" + index);
      $this
        .find(".swiper-button-next")
        .addClass("btn-content-category-rooms-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-content-category-rooms-" + index);
      let swiperContent = new Swiper(".instance-content-category-rooms-" + index, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        // observer: true,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination-content-category-rooms-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 2,
            spaceBetween: 75,
          },
        },
        navigation: {
          nextEl: ".btn-content-category-rooms-next-" + index,
          prevEl: ".btn-content-category-rooms-prev-" + index,
        },
      });
    });
    $(".block-swiper-content").each(function (index, element) {
      let $this = $(this);
      $this.children(".swiper").addClass("instance-content-" + index);
      $this.find(".swiper-button-prev").addClass("btn-content-prev-" + index);
      $this.find(".swiper-button-next").addClass("btn-content-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-content-" + index);
      let swiperContent = new Swiper(".instance-content-" + index, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        observer: true,

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
        pagination: {
          el: ".swiper-pagination-content-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        navigation: {
          nextEl: ".btn-content-next-" + index,
          prevEl: ".btn-content-prev-" + index,
        },
      });
    });
    $("#swiper-container-blog").each(function (index, element) {
      var $this = $(this);
      $this.children(".swiper").addClass("instance-blog-" + index);
      $this.find(".swiper-button-prev").addClass("btn-blog-prev-" + index);
      $this.find(".swiper-button-next").addClass("btn-blog-next-" + index);
      $this
        .find(".swiper-pagination")
        .addClass("swiper-pagination-blog-" + index);
      var swiperlinkedin = new Swiper(".instance-blog-" + index, {
        slidesPerView: 1,
        spaceBetween: 30,

        observer: true,

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
        pagination: {
          el: ".swiper-pagination-blog-" + index,
          type: "bullets",
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        navigation: {
          nextEl: ".btn-blog-next-" + index,
          prevEl: ".btn-blog-prev-" + index,
        },
      });
    });
  });
};